/**
 * Schedule Type IDs
 */
export const SCHEDULE_TYPE_IDS = {
    TAKING_ORDER: 1,
    PICKUP: 2,
    DELIVERY: 3,
};

/**
 * Mapping of API Weekday Index (0=Sun) to UI keys
 */
export const WEEKDAY_KEYS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];


/**
 * Converts the flat API schedule list to the nested internal structure
 * @param apiDataList
 * @returns {(*&{scheduleId: *})[]|*[]}
 */
export const convertApiToInternal = (apiDataList) => {
    // we intentionally set to empty array to ensure that the list is rendered even if there is no data to allow for operators to edit it.
    if (!apiDataList) return [];

    const getTimesForType = (typeId) => {
        const typeItems = apiDataList.filter(item => item.typeId === typeId && !item.specialDate);
        const exceptions = apiDataList.filter(item => item.typeId === typeId && item.specialDate);

        // Map weekly items to days
        const times = {};

        WEEKDAY_KEYS.forEach((key, index) => {
            // Find item for this weekday index
            const matchingItem = typeItems.find(item => item.weekDayIndex === index);
            if (matchingItem) {
                const startTime = matchingItem.startTime;
                const endTime = matchingItem.endTime;
                times[key] = {
                    startTime: startTime,
                    endTime: endTime,
                    id: matchingItem.id,
                    closed: startTime === null && endTime === null
                };
            } else {
                times[key] = null; // Not set in API
            }
        });

        // Map exceptions
        const mappedExceptions = exceptions.map(ex => ({
            id: ex.id,
            date: ex.specialDate,
            startTime: ex.startTime,
            endTime: ex.endTime,
            closed: !ex.startTime === null && !ex.endTime === null,
        }));

        return {
            scheduleId: typeId,
            times: times,
            exceptions: mappedExceptions
        };

    };

    return [
        {id: SCHEDULE_TYPE_IDS.TAKING_ORDER, ...getTimesForType(SCHEDULE_TYPE_IDS.TAKING_ORDER)},
        {id: SCHEDULE_TYPE_IDS.PICKUP, ...getTimesForType(SCHEDULE_TYPE_IDS.PICKUP)},
        {id: SCHEDULE_TYPE_IDS.DELIVERY, ...getTimesForType(SCHEDULE_TYPE_IDS.DELIVERY)},
    ].map(item => ({...item, scheduleId: item.id}));
};
